import React from 'react';
import './ExternalPageFooter.css';

const ExternalPageFooter = () => {
  return (
    <footer className="external-page-footer">
      <p className="footer-text">
        © 2024 Prontuário Fácil - Todos os direitos reservados.
      </p>
      <nav className="footer-nav">
        <ul className="nav-list">
          <li className="nav-item">
            <a
              href="https://prontuariofacil.com.br/politica-de-privacidade"
              className="nav-link"
            >
              Política de Privacidade
            </a>
          </li>
          <li className="nav-item">
            <a
              href="https://prontuariofacil.com.br/termos-de-uso"
              className="nav-link"
            >
              Termos de Serviço
            </a>
          </li>
        </ul>
      </nav>
    </footer>
  );
};

export default ExternalPageFooter;
